import { render, staticRenderFns } from "./AdWidget.vue?vue&type=template&id=cf60b5da&"
import script from "./AdWidget.vue?vue&type=script&lang=ts&"
export * from "./AdWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports